// このPaymtdを修正する場合はstudypf-backend/packages/event-bridge/src/types.tsにも同様の修正を加えること。
export enum Paymtd {
  Combined = "01",
  Credit = "02",
  WebMoney = "04",
  AuPay = "05",
  AuPayCard = "06",
}
